import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen w-full bg-white font-inter selection:bg-brandOrange/20 selection:text-navy flex flex-col" data-id="element-2">
          <Header data-id="element-3" />
          <main className="flex-grow" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
              <Route path="/services" element={<Services data-id="element-9" />} data-id="element-8" />
              <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
              <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
            </Routes>
          </main>
          <Footer data-id="element-14" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}